<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('customerName')">
          <el-input v-model="queryForm.name" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="$t('phone')">
          <el-input v-model="queryForm.phoneNo" size="small"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('riskProfile')">
          <el-select v-model="queryForm.riskProfile" size="small">
            <el-option :label="$t('all')" value=""></el-option>
            <el-option :label="$t('low')" value="0"></el-option>
            <el-option :label="$t('medium')" value="1"></el-option>
            <el-option :label="$t('high')" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isloading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isloading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
        v-if="this.loginInfo.orgType == 1 || this.loginInfo.orgType == 3"
      >
        <el-table-column
          type="selection"
          fixed="left"
          width="50"
        ></el-table-column>
        <el-table-column
          fixed="left"
          prop="id"
          :label="$t('ID')"
          width="100"
        ></el-table-column>
        <el-table-column prop="name" :label="$t('customerName')" width="160">
          <template slot-scope="scope">{{
            scope.row.name + " " + scope.row.surname
          }}</template>
        </el-table-column>
        <el-table-column
          prop="phoneNo"
          :label="$t('linkPhone')"
          min-width="160"
        ></el-table-column>
        <el-table-column
          prop="customerCode"
          :label="$t('customerCode')"
          width="160"
        ></el-table-column>

        <el-table-column
          prop="riskProfile"
          :label="$t('riskProfile')"
          width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.riskProfile == 0" class="text-primary">{{
              $t("low")
            }}</span>
            <span v-if="scope.row.riskProfile == 1" class="text-warning">{{
              $t("medium")
            }}</span>
            <span v-if="scope.row.riskProfile == 2" class="text-danger">{{
              $t("high")
            }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="status" :label="$t('status')" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-success">{{
              $t("normal")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-danger">{{
              $t("lock")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="idCard"
          :label="$t('idNumber')"
          min-width="200"
        ></el-table-column>
        <el-table-column prop="idImg" :label="$t('idCard')" min-width="200">
          <template slot-scope="scope">
            <el-image
              style="max-height:23px;"
              :src="scope.row.idImgs ? scope.row.idImgs[0] : ''"
              :preview-src-list="scope.row.idImgs"
            >
              <div slot="error" class="image-slot">
                <img
                  :src="imgError"
                  style="max-height:23px;vertical-align: text-top;"
                />
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="expireDate"
          :label="$t('expireDate')"
          width="220"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.expireDate).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column
          prop="nationality"
          :label="$t('nationality')"
          min-width="160"
        >
          <template slot-scope="scope">{{
            getCountryName(scope.row.countryCode)
          }}</template>
        </el-table-column>
        <el-table-column prop="gender" :label="$t('sex')" min-width="160">
          <template slot-scope="scope">{{
            $t("sex" + scope.row.gender)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="marryStatus"
          :label="$t('maritalStatus')"
          min-width="160"
        >
          <template slot-scope="scope">{{
            $t("maritalStatus" + scope.row.marryStatus)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="address"
          :label="$t('address')"
          min-width="160"
        ></el-table-column>
        <el-table-column
          prop="incomeLevel"
          :label="$t('incomeLevel')"
          min-width="160"
        >
          <template slot-scope="scope"
            ><span class="franc">₣</span>
            {{
              String(scope.row.incomeLevel)
                .split(".")[0]
                .formatMoney(0)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="phoneNoBak"
          :label="$t('alternatePhone')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.phoneNoBak1 || "" }}</span>
            <span style="margin:0 10px"></span>
            <span>{{ scope.row.phoneNoBak2 || "" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('area')" min-width="300">
          <template slot-scope="scope">
            {{ getArea([scope.row.country, scope.row.region, scope.row.city]) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="remark"
          :label="$t('remark')"
          min-width="300"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('creationTime')"
          width="220"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.createTime).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('extend')" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="openCheckApply(scope.row)"
              type="primary"
              >{{ $t("edit") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />
    <el-drawer
      :title="$t('Validation')"
      :visible.sync="isCheckApply"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form
        :model="checkForm"
        ref="checkForm"
        label-position="top"
        :rules="rules"
      >
        <el-form-item :label="$t('ID')" prop="id">
          <el-input size="medium" v-model="checkForm.id" disabled="" />
        </el-form-item>

        <el-form-item :label="$t('riskProfile')">
          <el-select v-model="checkForm.riskProfile" size="small">
            <el-option :label="$t('low')" value="0"></el-option>
            <el-option :label="$t('medium')" value="1"></el-option>
            <el-option :label="$t('high')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-divider content-position="left">{{
          $t("personalData")
        }}</el-divider>
        <el-form-item :label="$t('idNumber')" prop="idCard">
          <el-input size="medium" v-model="checkForm.idCard"></el-input>
        </el-form-item>
        <el-form-item :label="$t('expireDate')" prop="expireDate">
          <el-date-picker
            v-model="checkForm.expireDate"
            type="date"
            :format="'yyyy-MM-dd'"
            :placeholder="$t('selectDateAndTime')"
            style="width: 100%;"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('sex')" prop="gender">
          <el-select
            size="medium"
            v-model="checkForm.gender"
            style="width: 100%;"
          >
            <el-option :label="$t('sex1')" :value="1"></el-option>
            <el-option :label="$t('sex0')" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('nationality')" prop="nationality">
          <el-select
            size="medium"
            v-model="checkForm.nationality"
            filterable
            :placeholder="$t('Please select country')"
            style="width: 100%;"
          >
            <el-option
              v-for="item in countryList2"
              :key="item.id"
              :label="$i18n.locale === 'fr' ? item.nameFr : item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('maritalStatus')" prop="marryStatus">
          <el-select size="medium" v-model="checkForm.marryStatus">
            <el-option :label="$t('maritalStatus0')" :value="0"></el-option>
            <el-option :label="$t('maritalStatus1')" :value="1"></el-option>
            <el-option :label="$t('maritalStatus2')" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('detailedAddress')" prop="address">
          <el-input size="medium" v-model="checkForm.address"></el-input>
        </el-form-item>
        <el-form-item :label="$t('incomeLevel')" prop="incomeLevel">
          <el-input type="number" size="medium" v-model="checkForm.incomeLevel">
            <template slot="prepend"
              ><i class="iconfont iconruishifalang" style="font-size:14px"></i>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            @click="updateSubmit('checkForm')"
            :loading="isloading"
          >
            {{ $t("submit") }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import customer from "@/api/customer";
import org from "@/api/org";
import { countries } from "@/assets/data/countries";
import manba from "@/assets/uilt/manbaDate";
export default {
  name: "customersList",
  data() {
    return {
      queryForm: { type: "5" },
      checkForm: {},
      //table高度，动态设置
      queryTableHeight: String,
      //table显示内容
      tableData: {},
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,
      isCheckApply: false,
      countryList2: countries,

      isloading: false,

      orgList: [],
      lockAccount: {
        drawer: false,
        form: {},
        row: {},
      },
    };
  },
  computed: {
    displayCountries() {
      return countries
        .map((c) => ({
          id: c.id,
          name: this.$i18n.locale === "fr" ? c.nameFr : c.name, //  Use this.$i18n.locale
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    imgError() {
      return this.$store.state.system.imgError;
    },
    rules() {
      return {
        idCard: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        expireDate: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        nationality: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],

        marryStatus: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        incomeLevel: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  watch: {
    /**选中省份后清空城市 */
    "queryForm.region"() {
      this.$set(this.queryForm, "city", "");
    },
    // "queryForm.city" (value) {
    //   console.log("-----city------", value)
    //   if (!value || this.queryForm.region) return;
    //   let city = this.countryList.find(function (item) { return item.id == value });
    //   this.queryForm.region = city.parentId;
    // }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "-";

      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    getCountryName(countryCode) {
      if (!countryCode) return "-";

      const nationality = this.countryList2.find((c) => c.id === countryCode);
      if (!nationality) return countryCode;

      // Return name based on current language
      return this.$i18n.locale === "fr" ? nationality.nameFr : nationality.name;
    },
    /**获取客户列表 */
    getList() {
      let _this = this;
      _this.isloading = true;
      customer.getPage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm,
        },
        success: (res) => {
          _this.isloading = false;
          if (res.code != 200) {
            _this.tableData = {};
            return;
          }
          for (let i = 0; i < res.data.records.length; i++) {
            let l = res.data.records[i];
            l.idImgs = l.idImg ? l.idImg.split(",") : l.idImg;
          }
          _this.tableData = res.data;
        },
      });
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getArea(arr) {
      let text = "";
      for (let i = 0; i < arr.length; i++) {
        let g = this.countryList.find(function(t) {
          return t.id == arr[i];
        });
        text += (g ? g.name : "") + " / ";
      }
      return text.substring(0, text.length - 3);
    },
    getOrgList() {
      let _this = this;
      org.getOrgInfoPage({
        param: { current: 1, size: 10000 },
        success: (res) => {
          if (res.data) _this.orgList = res.data.records;
        },
      });
    },
    openCheckApply(row) {
      this.isCheckApply = true;
      this.checkForm = {
        id: row.id,
        //riskProfile: row.riskProfile,
        riskProfile: row.riskProfile?.toString() || null,
        idCard: row.idCard,
        expireDate: row.expireDate?.toString(),
        gender: row.gender,
        nationality: row.nationality?.toString() || null,
        marryStatus: row.marryStatus,
        address: row.address,
        incomeLevel: row.incomeLevel,
      };
    },
    updateSubmit(formName) {
      let _this = this;
      _this.isloading = true;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this[formName].expireDate = manba(_this[formName].expireDate).format(
            "ymdhms"
          );
          let aubmitForm = JSON.parse(JSON.stringify(_this.checkForm));

          customer.updateRiskProfile({
            param: aubmitForm,
            success: (res) => {
              if (res.code == 200) {
                _this.$message({
                  type: "success",
                  message: _this.$t("operateSuccessfully"),
                });
                _this.getList();
                _this.isCheckApply = false;
              } else {
                _this.$message({ type: "warning", message: _this.$t(res.msg) });
              }
              _this.isloading = false;
            },
          });
        }
      });
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getList();

    if (this.loginInfo.orgType == 1 || this.loginInfo.orgType == 3) {
      this.getOrgList();
    }
  },
};
</script>

<style></style>
